<template>
  <div class="loader-container" data-testid="investment-section-loader">
    <SkeletonLoader show-animation>
      <div class="loader loader--subtitle" />
    </SkeletonLoader>

    <SkeletonLoader show-animation>
      <div class="loader loader--input" />
    </SkeletonLoader>

    <SkeletonLoader class="suggestions-group" show-animation>
      <div
        v-for="suggestion in 4"
        :key="suggestion"
        class="loader loader--suggestion"
      />
    </SkeletonLoader>

    <SkeletonLoader class="actions-group" show-animation>
      <div class="loader loader--action" />
    </SkeletonLoader>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  name: 'InvestmentSectionLoader',
  components: { SkeletonLoader }
})
export default class InvestmentSectionLoader extends Vue {}
</script>

<style lang="less" scoped>
@mobile-row-height: 77px;
@desktop-row-height: 53px;

.loader {
  border-radius: 10px;
  background: @background-tertiary;

  &--subtitle {
    height: @mobile-row-height;
    margin-top: @size-spacing-x300;
    margin-bottom: @size-spacing-x300;
  }

  &--input {
    margin-top: 72px;
    height: 48px;
  }

  &--suggestion {
    display: inline-block;
    height: 34px;
    width: 70px;
  }

  &--action {
    height: 40px;
    width: 220px;
  }

  @media (min-width: 30em) /* 480px */ {
    &--subtitle {
      height: @desktop-row-height;
    }

    &--input {
      height: 92px;
    }
  }
}

.suggestions-group {
  margin: @size-spacing-x400 0 @size-spacing-x1000;
  white-space: nowrap;
  overflow: hidden;

  > * {
    margin-right: @size-spacing-x350;
  }
}

.actions-group {
  display: none;

  @media (min-width: 59.375em) /* 950px */ {
    display: block;
  }
}
</style>
